import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "container", "preview"]

  update() {
    this.releaseObjectUrl()

    const file = this.inputTarget.files?.[0]
    if (!file || !file.type.startsWith("image/")) {
      this.hidePreview()
      return
    }

    this.objectUrl = URL.createObjectURL(file)
    this.previewTarget.src = this.objectUrl
    this.previewTarget.hidden = false
    this.containerTarget.hidden = false
  }

  disconnect() {
    this.releaseObjectUrl()
  }

  hidePreview() {
    this.previewTarget.removeAttribute("src")
    this.previewTarget.hidden = true
    this.containerTarget.hidden = true
  }

  releaseObjectUrl() {
    if (!this.objectUrl) return

    URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
